import React, { useEffect, useState } from 'react';
import styles from './style.module.css';

export default function Tabs(props) {
  const {
    tabData,
    parentComponentName,
    setCategoryTitle,
    setContentData,
    contentData,
    handleChangeTab,
  } = props;
  const [isActiveList, setIsActiveList] = useState([]);

  function handleClickTab(e, index) {
    const newList = [];
    tabData.forEach((item, i) => {
      if (i === index) {
        newList.push(true);
        // check if category custom, change the number (-2)
        if (+item.categoryId === 98 || +item.categoryId === 99)
          setCategoryTitle(`${i - 1}. ${tabData[i].categoryName}`);
        else setCategoryTitle(`${i + 1}. ${tabData[i].categoryName}`);

        // --for Dummy--
        // if (i === 0 || i === 2) {
        //   setContentData(contentData[0]);
        // } else if (i === 1 || i === 3) {
        //   setContentData(contentData[1]);
        // }

        // --for API--
        handleChangeTab(item.categoryId);
      } else {
        newList.push(false);
      }
    });

    setIsActiveList(newList);
  }

  // useEffect specifically for first load tabData active
  useEffect(() => {
    if (isActiveList.length === 0) {
      const tabCount = tabData && tabData.length;
      const newList = [];

      for (let index = 0; index < tabCount; index++) {
        if (index === 0) {
          newList.push(true);
        } else {
          newList.push(false);
        }
      }
      setIsActiveList(newList);
    }
  }, [tabData]);

  return (
    <div className={styles.root}>
      {tabData &&
        tabData.map((item, index) => {
          // hide default water source & body tabs
          if (+item.categoryId === 10 || +item.categoryId === 11) {
            return '';
          }
          return (
            <TabItem
              key={`tab-${parentComponentName}-${item.categoryId}`}
              id={item.categoryId}
              name={item.categoryName}
              parentComponentName={parentComponentName}
              isActive={isActiveList[index]}
              index={index}
              onClick={(e) => handleClickTab(e, index)}
            />
          );
        })}
    </div>
  );
}

const TabItem = (props) => {
  const { name, isActive, onClick, index } = props;
  const tabItemClasses = [
    styles.tabItem,
    isActive && styles.active,
    index === 0 && styles.firstItem,
  ].join(' ');

  return (
    <div className={tabItemClasses} onClick={onClick}>
      {name}
    </div>
  );
};
